// eslint-disable-next-line import/no-anonymous-default-export
export default {
  section: {
    main: 'MAIN',
    pages: 'PAGES',
    customerCompany: 'Müşteri & Firma',
    customerCompanyDesc: 'Müşteri ve firma yönetimi',
    infrastructure: 'Altyapı & Ödemeler',
    infrastructureDesc: 'Altyapı yönetimi - Sunucular ve domain kayıt firmaları',
    pricing: 'Fiyat Tanımlamaları',
    pricingDesc: 'Fiyat yönetimi - Domain ve hosting fiyat tanımlamaları',
    system: 'System',
    systemDesc: 'Sistem yönetimi - Kullanıcılar, veri yönetimi ve sistem ayarları'
  }
};
